import React, { Component } from "react";

import styles from "./ListItem.module.css";

export default function ListItem(props) {
  const { isLegend, id, postNum, title, userName, date, move } = props;
  return isLegend == true ? (
    <div className={styles.LegendItem}>
      <div className={styles.PostNum}>번호</div>
      <div className={styles.Title}>글 제목</div>
      <div className={styles.UserName}>작성자</div>
      <div className={styles.Date}>작성 날짜</div>
    </div>
  ) : (
    <div
      className={styles.ListItem}
      onClick={() => {
        move(id);
      }}
    >
      <div className={styles.PostNum}>{postNum}</div>
      <div className={styles.Title}>{title}</div>

      <div className={styles.UserName}>
        {userName == undefined ? "관리자" : userName}
      </div>
      <div className={styles.Date}>{date}</div>
    </div>
  );
}
